import TagManager from 'react-gtm-module';

import { restApiService } from '../services/services';
import { axiosStorableError } from '../util/errors';
import { handleAxiosResponse } from '../util/apiHelpers';

const GET_HOSTED_PAGE_REQUEST = 'app/Chargebee/GET_HOSTED_PAGE_REQUEST';
const GET_HOSTED_PAGE_SUCCESS = 'app/Chargebee/GET_HOSTED_PAGE_SUCCESS';
const GET_HOSTED_PAGE_ERROR = 'app/Chargebee/GET_HOSTED_PAGE_ERROR';

const GET_CHARGE_DATA_REQUEST = 'app/Chargebee/GET_CHARGE_DATA_REQUEST';
const GET_CHARGE_DATA_SUCCESS = 'app/Chargebee/GET_CHARGE_DATA_SUCCESS';
const GET_CHARGE_DATA_ERROR = 'app/Chargebee/GET_CHARGE_DATA_ERROR';

const RESET_STATE = 'app/Chargebee/RESET_STATE';

const initialChargeData = {
  1: { title: '', price: 0 },
  2: { title: '', price: 0 },
};

const initialState = {
  getHostedPageInProgress: false,
  getHostedPageError: null,
  getChargeDataInProgress: false,
  getChargeDataError: null,
  chargeData: initialChargeData,
};

export default function chargebeeReducer(state = initialState, action = {}) {
  const {
    type,
    payload,
  } = action;

  switch (type) {
    case GET_HOSTED_PAGE_REQUEST:
      return {
        ...state,
        getHostedPageInProgress: true,
        getHostedPageError: null,
      };

    case GET_HOSTED_PAGE_SUCCESS:
      return {
        ...state,
        getHostedPageInProgress: false,
      };

    case GET_HOSTED_PAGE_ERROR:
      return {
        ...state,
        getHostedPageInProgress: false,
        getHostedPageError: payload,
      };

    case GET_CHARGE_DATA_REQUEST:
      return {
        ...state,
        getChargeDataInProgress: true,
        getChargeDataError: null,
      };

    case GET_CHARGE_DATA_SUCCESS:
      return {
        ...state,
        getChargeDataInProgress: false,
        chargeData: payload,
      };

    case GET_CHARGE_DATA_ERROR:
      return {
        ...state,
        getChargeDataInProgress: false,
        getChargeDataError: payload,
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
}

const getHostedPageRequest = () => {
  return {
    type: GET_HOSTED_PAGE_REQUEST,
  };
};

const getHostedPageSuccess = () => {
  return {
    type: GET_HOSTED_PAGE_SUCCESS,
  };
};

const getHostedPageError = error => {
  return {
    type: GET_HOSTED_PAGE_ERROR,
    payload: error,
  };
};

const getChargeDataRequest = () => {
  return {
    type: GET_CHARGE_DATA_REQUEST,
  };
};

const getChargeDataSuccess = data => {
  return {
    type: GET_CHARGE_DATA_SUCCESS,
    payload: data,
  };
};

const getChargeDataError = error => {
  return {
    type: GET_CHARGE_DATA_ERROR,
    payload: error,
  };
};

const $subState = state => {
  return state.Chargebee;
};

export const $getHostedPageState = state => {
  const subState = $subState(state);
  return {
    inProgress: subState.getHostedPageInProgress,
    error: subState.getHostedPageError,
  };
};

export const $chargeDataState = state => {
  const subState = $subState(state);
  return {
    data: subState.chargeData,
    inProgress: subState.getChargeDataInProgress,
    error: subState.getChargeDataError,
  };
};

export const getChargeData = categoryName => dispatch => {
  dispatch(getChargeDataRequest());
  return restApiService.secureInstance
    .getRaw('chargebee/charge-data', {
      params: { categoryName },
    })
    .then(handleAxiosResponse)
    .then(resp => {
      dispatch(getChargeDataSuccess(resp));
      return resp;
    })
    .catch(e => {
      dispatch(getChargeDataError(axiosStorableError(e)));
      throw e;
    })
    ;
};

export const getHostedPage = (
  categoryName,
  listingId,
  listingState,
  chargeData,
  currentUserId
) => dispatch => {
  dispatch(getHostedPageRequest());
  return restApiService.secureInstance
    .postRaw('chargebee/one-time-checkout', {
      listingId,
      listingState,
      categoryName,
      priceItemId: chargeData.priceItemId,
    })
    .then(handleAxiosResponse)
    .then(resp => {
      TagManager.dataLayer({
        dataLayer: {
          event: 'open_chargebee_form_for_featured_listing_success',
          listing_id: listingId,
          user_id: currentUserId,
        },
      });
      dispatch(getHostedPageSuccess());
      window.open(resp.hosted_page.url, '_blank');
      return resp;
    })
    .catch(e => {
      TagManager.dataLayer({
        dataLayer: {
          event: 'open_chargebee_form_for_featured_listing_error',
          listing_id: listingId,
          user_id: currentUserId,
        },
      });
      dispatch(getHostedPageError(axiosStorableError(e)));
      throw e;
    })
  ;
};

export const resetChargebeeState = () => dispatch => {
  dispatch({ type: RESET_STATE });
};
